import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { ReactNode } from 'react'

interface FlyoutState {
  open: boolean
  flyoutContent: ReactNode | null
  direction: 'right' | 'left' | 'top' | 'bottom'
  title?: string | null
  titleIcon?: IconDefinition | null
  footer: ReactNode | null
  description?: string | null
  preventClose?: (() => boolean) | null
}

const initialState: FlyoutState = {
  open: false,
  flyoutContent: null,
  title: null,
  direction: 'right',
  titleIcon: null,
  footer: null,
  description: null,
  preventClose: null,
}

const flyoutSlice = createSlice({
  name: 'flyout',
  initialState,
  reducers: {
    // Deprecated: Used for Design System 1
    openFlyout: (
      state,
      {
        payload,
      }: PayloadAction<{
        content: ReactNode
        title?: string
        direction?: 'right' | 'left' | 'top' | 'bottom'
        titleIcon?: IconDefinition
        footer?: ReactNode
        description?: string
        preventClose?: (() => boolean) | null
      }>
    ) => {
      state.open = true
      state.flyoutContent = payload.content
      state.direction = payload.direction || 'right'
      state.title = payload.title
      state.titleIcon = payload.titleIcon
      state.footer = payload.footer
      state.description = payload.description
      state.preventClose = payload.preventClose || null
    },
    // Deprecated: Used for Design System 1
    closeFlyout: (state) => {
      state.open = false
      state.flyoutContent = null
      state.title = null
      state.titleIcon = null
      state.footer = null
      state.description = null
    },
    // New: Used for Design System 2
    openFlyoutV2: (
      state,
      {
        payload,
      }: PayloadAction<{
        title?: string
        direction?: 'right' | 'left' | 'top' | 'bottom'
        titleIcon?: IconDefinition
        footer?: ReactNode
        description?: string
      }>
    ) => {
      state.open = true
      state.direction = payload.direction || 'right'
      state.title = payload.title ?? null
      state.titleIcon = payload.titleIcon ?? null
      state.footer = payload.footer ?? null
      state.description = payload.description ?? null
    },
    // New: Used for Design System 2
    closeFlyoutV2: (state) => {
      state.open = false
      state.title = null
      state.titleIcon = null
      state.footer = null
      state.description = null
    },
  },
})
export const {
  openFlyout: setFlyoutContent,
  closeFlyout: clearFlyoutContent,
  openFlyoutV2,
  closeFlyoutV2,
} = flyoutSlice.actions

export default flyoutSlice.reducer
